import { appConfig } from '@common/config';
import useClickAway from '@hook/useClickAway';
import classNames from 'classnames';
import { Suspense, lazy, useEffect, useRef, useState, type ComponentType } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Title } from './Title';
import ItemIndexBns from './type_itemdict/ItemIndexBns';

const ItemIdxLm = lazy(() => import('./type_item/ItemIndexLm'));
const ItemIdxL2m = lazy(() => import('./type_item/ItemIndexL2m'));
const ItemIndexLineageClassic = lazy(() => import('./type_linclassic/ItemIndexLineageClassic'));

const componentMap: Record<string, ComponentType<any>> = {
    l2m: ItemIdxL2m,
    lms: ItemIdxLm,
    bnsneo: ItemIndexBns,
    linclassic: ItemIndexLineageClassic,
};

export const Index = ({ paramDetail }: { paramDetail: string | null }) => {
    const CurrentIndex = componentMap[appConfig.service];
    const [URLSearchParams, SetURLSearchParams] = useSearchParams();
    const secRef = useRef<HTMLDivElement>(null);
    const wrapRef = useRef<HTMLDivElement>(null);

    const [isShow, isShowSet] = useState(false);
    const [detailNow, setDetailNow] = useState<string | undefined>('');
    const [detailSvr, setDetailSvr] = useState<string | undefined>('');
    const [detailEnchant, setDetailEnchant] = useState<string | undefined>('');
    const [detailLevel, setDetailLevel] = useState<string | undefined>('');
    const [detailId, setDetailId] = useState<string | undefined>('');
    const [escapeCount, setEscapeCount] = useState(0);

    useEffect(() => {
        if (paramDetail === null) return;
        const tempArr: string[] = paramDetail.split('_');
        setDetailNow(tempArr.shift());
        setDetailSvr(tempArr.pop());
        if (appConfig.service === 'bnsneo') {
            setDetailLevel(tempArr.pop());
        } else {
            setDetailEnchant(tempArr.pop());
        }
        setDetailId(tempArr.join('_'));
    }, [paramDetail]);

    useEffect(() => {
        const showModal = !!detailId && (
            detailId !== '0' ||
            detailNow === 'spell' ||
            detailNow === 'monster'
        );
        isShowSet(showModal);
    }, [detailId, detailNow]);


    useEffect(() => {
        const bodyElement = document.querySelector('body');
        if (bodyElement) {
            bodyElement.style.overflow = isShow ? 'hidden' : '';
        }
    }, [isShow]);

    useEffect(() => {
        if (escapeCount < 1) {
            return;
        }
        URLSearchParams.set('detail', ``);
        SetURLSearchParams(URLSearchParams);
        secRef.current?.scrollTo({ top: 0 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [escapeCount]);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setEscapeCount((prev) => prev + 1);
        };
        document.addEventListener('keydown', (e) => handleKeyDown(e), true);
        return () => {
            document.removeEventListener('keydown', (e) => handleKeyDown(e), true);
        };
    }, []);

    useClickAway(wrapRef, (e) => {
        const target = e.target as HTMLElement;
        if (target.className !== 'toast-cancel' && isShow) {
            URLSearchParams.set('detail', ``);
            SetURLSearchParams(URLSearchParams);
            secRef.current?.scrollTo({ top: 0 });
        }
    });

    const detailprops = {
        detailNow,
        detailSvr,
        detailEnchant,
        detailLevel,
        detailId,
    };

    return (
        <div className={classNames({ 'is-active': isShow }, 'gameinfo-detail-wrapper')}>
            <div className="gameinfo-detail" ref={wrapRef}>
                <Title props={detailprops} />
                <div className="gameinfo-detail__section" ref={secRef}>
                    {isShow && (
                        <Suspense
                            fallback={
                                <div className="gameinfo-loader is-show">
                                    <span className="loader" />
                                </div>
                            }
                        >
                            <CurrentIndex props={detailprops} />
                        </Suspense>
                    )}
                </div>
            </div>
        </div>
    );
};
